import { createContext, useContext } from "react";

import { Schemas } from "../../../types";

export type CredentialTemplate =
  Schemas["CredentialVerificationTemplateCreate"];

export const initialCredentialTemplateValues: CredentialTemplate = {
  name: "",
  check_arguments: {
    minimum: 1,
    maximum: 5,
  },
};

export interface CredentialTemplatesContextType {
  credentialTemplate: CredentialTemplate;
  setCredentialTemplate: (credentialTemplate: CredentialTemplate) => void;
}

export const CredentialTemplatesContext =
  createContext<CredentialTemplatesContextType>({
    credentialTemplate: initialCredentialTemplateValues,
    setCredentialTemplate: (newState: CredentialTemplate) => newState,
  });

export function useCredentialTemplatesContext() {
  return useContext(CredentialTemplatesContext);
}
